import { Injectable } from '@angular/core'
import { WebService } from '../api/web.service'
import { ServiceUrlConstants } from 'src/app/constants/service-url-constants'
import { HttpHeaders } from '@angular/common/http'
import { Observable, catchError, map, of } from 'rxjs'
import { CommonService } from './common.service'

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  constructor(private webService: WebService, private cs: CommonService) {}

  uploadDocument(moduleType: string, referenceId: string, docType: string, file: File): Observable<any> {
    const endPoint = ServiceUrlConstants.createUploadDocumentEndpoint(docType, moduleType, referenceId)
    const formData = new FormData()
    formData.append('document', file)
    const headers = new HttpHeaders()
    headers.append('Content-Type', 'multipart/form-data')
    return this.webService.uploadDocument(endPoint, formData, headers).pipe(map((data: any) => data))
  }

  uploadDocumentToCompany(
    moduleType: string,
    referenceId: string,
    docType: string,
    file: File,
    companyId: string,
    query?: string
  ): Observable<any> {
    const endPoint = `${ServiceUrlConstants.createUploadDocumentEndpoint(docType, moduleType, referenceId)}&${
      query || ''
    }`
    const formData = new FormData()
    formData.append('document', file)
    let headers = new HttpHeaders()
    headers = headers.append('x-companyEntityId', companyId)
    return this.webService.uploadDocument(endPoint, formData, headers).pipe(map((data: any) => data))
  }

  uploadDocuments(moduleType: string, docType: string, files: FileList, referenceId?: string): Observable<any[]> {
    const endPoint = ServiceUrlConstants.createUploadDocumentEndpoint(docType, moduleType, referenceId)

    const data = []
    const endPoints = []

    for (let i = 0; i < files.length; i++) {
      const formData = new FormData()
      formData.append('document', files[i])
      data.push(formData)
      endPoints.push(endPoint)
    }
    return this.webService.makeParallelPostAPICalls(data, endPoints)
  }

  downloadDocument(
    endPoint: string,
    options?: { queryParams?: {}[]; requestBody?: any },
    expectedFileName?: string,
    headers?: HttpHeaders
  ) {
    const { queryParams, requestBody } = options || {}
    let documentResponse$: Observable<any>
    if (options) {
      documentResponse$ = this.webService.downloadFilePOST(endPoint, queryParams, requestBody, headers)
    } else {
      documentResponse$ = this.webService.downloadFileGET(endPoint, headers)
    }

    documentResponse$
      .pipe(
        map(response => {
          const contentDispositionHeader: string | null = response.headers.get('content-disposition')
          const filenameMatches: RegExpMatchArray | null = contentDispositionHeader?.match(/filename=["'](.+?)["']/)
          let blob: Blob = response.body
          let a = document.createElement('a')
          a.download = filenameMatches?.[1] || expectedFileName || 'file.pdf'
          a.href = window.URL.createObjectURL(blob)
          a.click()
        }),
        catchError((error: any) => {
          this.cs.showError(`Unable to download document at this time`)
          return of(null)
        })
      )
      .subscribe()
  }

  deleteDocument(documentId: string, headers?: HttpHeaders): Observable<any> {
    const endPoint = `${ServiceUrlConstants.API_DOWNLOAD_DELETE_DOCUMENT}${documentId}`
    return this.webService.delete(endPoint, null, headers)
  }

  previewDocument(
    endPoint: string,
    options?: { queryParams?: {}[]; requestBody?: any },
    headers?: HttpHeaders
  ): Observable<string> {
    const { queryParams, requestBody } = options || {}
    let documentResponse$: Observable<any>
    if (options) {
      documentResponse$ = this.webService.downloadFilePOST(endPoint, queryParams, requestBody, headers)
    } else {
      documentResponse$ = this.webService.downloadFileGET(endPoint, headers)
    }

    return documentResponse$.pipe(
      map(response => {
        const contentDispositionHeader: string | null = response.headers.get('content-disposition')
        const filenameMatches: RegExpMatchArray | null = contentDispositionHeader?.match(/filename=["'](.+?)["']/)
        const blob: Blob = response.body
        const contentType = filenameMatches?.[1] || 'file.pdf'
        const documentUrl = window.URL.createObjectURL(blob)
        const documentUrlWithType = `${documentUrl}?type=${contentType}`
        return documentUrlWithType
      }),
      catchError((error: any) => {
        this.cs.showError(`Unable to preview document at this time`)
        return of(null)
      })
    )
  }
}
